// The upload of a custom emoji or sticker, from the settings page. Its location is removed first and the copy is read
// back (#352), with the same cleaner as every other upload; but a picture the cleaner can't handle is refused, not drawn
// again as a JPEG, which would lose the transparency and the animation an emoji needs.
import { ApiError } from "./api.ts";
import { refusalMessage } from "@bloom/shared";
import { CleanError, stripLocation } from "./stripLocation.ts";
import { CLIENT } from "./upload.ts";

export type CustomKind = "emoji" | "sticker";
const path = (serverId: string, kind: CustomKind) => `/servers/${serverId}/${kind === "emoji" ? "emoji" : "stickers"}`;

export async function uploadCustom(serverId: string, kind: CustomKind, file: File, name: string): Promise<void> {
  let safe: File;
  try {
    safe = (await stripLocation(file)).file;
  } catch (e) {
    if (e instanceof CleanError) throw new Error(refusalMessage(e.subject, e.reason, e.label));
    throw e;
  }
  const res = await fetch(`/api${path(serverId, kind)}?name=${encodeURIComponent(name)}`, {
    method: "PUT",
    body: safe,
    credentials: "same-origin",
    headers: { "content-type": safe.type || "application/octet-stream", "x-bloom-client": CLIENT },
  });
  if (!res.ok) {
    const j = (await res.json().catch(() => null)) as { message?: string } | null;
    throw new ApiError(res.status, j?.message ?? `Upload failed (${res.status}).`);
  }
}
